import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "preview"]

  browse() {
    this.inputTarget.click()
  }

  preview(event) {
    const file = event.target.files[0]
    if (file && file.type.startsWith("image/")) {
      const reader = new FileReader()
      reader.onload = (e) => {
        this.previewTarget.innerHTML = `<img src="${e.target.result}" class="w-full h-full object-cover" alt="Profile preview" />`
      }
      reader.readAsDataURL(file)
    }
  }
}
